module.exports = __webpack_public_path__ + "img/marine_screenshot_3.6a9980aa.jpg";